<div class="fab dekstop-width-limiter {{ style }}" [routerLink]="routerLink">
  @if (!icon) {
    <img src="./assets/images/FAB.svg">
  }
  @if (icon) {
    <div class="icon"><mat-icon >{{icon}}</mat-icon></div>
  }
</div>